import React from "react";
import { Dropdown, SplitButton } from "react-bootstrap";
import Checkbox from "../../generic/CheckBoxGeneric";
import EdButton from "../../generic/edbutton/edButton";
import { updateChecked, } from "../../generic/FilterSidbar/GenericFilterSidebar";
import { SearchAssetTypeEnum } from "@frameworks/web/components/Search/constant";
const GenericDropdownTabs = (props) => {
    var _a, _b;
    const [tab, setTab] = React.useState(props.defaultActiveKey
        ? props.defaultActiveKey
        : props.tabsArray[0].eventKey);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "search-toptabs-block" }, (props === null || props === void 0 ? void 0 : props.tabsArray) &&
            ((_a = props === null || props === void 0 ? void 0 : props.tabsArray) === null || _a === void 0 ? void 0 : _a.map((tabitem, idx) => {
                var _a, _b;
                const filterList = props.filterList.find((x) => x.eventKey === tabitem.value && tabitem.filters);
                let subTitle = "";
                let count = [];
                (_a = filterList === null || filterList === void 0 ? void 0 : filterList.list) === null || _a === void 0 ? void 0 : _a.map((x) => {
                    if (x.selected) {
                        count.push(x.title);
                    }
                });
                if (count.length === 1) {
                    subTitle = count[0];
                }
                if (count.length > 1) {
                    subTitle = "";
                    if (tabitem.value === SearchAssetTypeEnum.Equity) {
                        subTitle = count[0] + `& ${count[1]}`;
                    }
                    else {
                        subTitle = count[0] + `& ${count.length - 1} more`;
                    }
                }
                return (React.createElement(React.Fragment, null, !!filterList ? (React.createElement(SplitButton, { align: { lg: "start" }, 
                    // flip={true}
                    key: "success", id: `dropdown-split-variants-success dropdown-menu-align-responsive-2`, title: tabitem.title + `${!!subTitle ? ": " + subTitle : ""}`, onClick: () => {
                        setTab(tabitem.eventKey);
                        props.forceUpdateTab &&
                            props.forceUpdateTab(tabitem.eventKey);
                        if (props.searchString &&
                            (tabitem.value === SearchAssetTypeEnum.Option ||
                                tabitem.value === SearchAssetTypeEnum.ComOpt)) {
                            props.setOptions(true);
                        }
                        else {
                            props.setOptions(false);
                        }
                        props.onCallBackFunction &&
                            tabitem.value === SearchAssetTypeEnum.Equity &&
                            props.onCallBackFunction();
                    }, onToggle: (e) => {
                        if (e) {
                            setTab(tabitem.eventKey);
                            props.forceUpdateTab &&
                                props.forceUpdateTab(tabitem.eventKey);
                            if (props.searchString &&
                                (tabitem.value === SearchAssetTypeEnum.Option ||
                                    tabitem.value === SearchAssetTypeEnum.ComOpt)) {
                                props.setOptions(true);
                            }
                            else {
                                props.setOptions(false);
                            }
                            props.onCallBackFunction &&
                                tabitem.value === SearchAssetTypeEnum.Equity &&
                                props.onCallBackFunction();
                        }
                    }, autoClose: true, className: `search-split-block ${tabitem.title == tab ? "search-tab-active-btn" : ""}` }, (_b = filterList.list) === null || _b === void 0 ? void 0 : _b.map((item, id) => {
                    return filterList.selectType === "checkbox" ? (React.createElement(Checkbox, { className: "common-checkbox-custom small-checkbox alignment-content", list: { display: item.title, value: item.key }, name: item.title, selected: item.selected ? item.key : "", onChange: (e) => {
                            updateChecked(e, filterList.filterName, id, props.setFilter);
                        } })) : tabitem.dropType === "radio" ? (React.createElement(React.Fragment, null)) : (React.createElement(Dropdown.Item, { onClick: (e) => {
                            updateChecked(e, filterList.filterName, id, props.setFilter, "tab");
                            if (tabitem.value === SearchAssetTypeEnum.Currency &&
                                item.key === "OPT") {
                                props.setOptions(true);
                            }
                            else {
                                props.setOptions(false);
                            }
                        } }, item.title));
                }))) : (React.createElement("div", { className: `search-nosplit-block ${tabitem.title == tab
                        ? "search-tab-active-btn selected-tab-color"
                        : ""}` },
                    React.createElement(EdButton, { type: "button", value: tabitem.title, onClick: () => {
                            setTab(tabitem.eventKey);
                            props.forceUpdateTab &&
                                props.forceUpdateTab(tabitem.eventKey);
                            if (props.searchString &&
                                (tabitem.value === SearchAssetTypeEnum.Option ||
                                    tabitem.value === SearchAssetTypeEnum.ComOpt)) {
                                props.setOptions(true);
                            }
                            else {
                                props.setOptions(false);
                            }
                        }, btnTyp: "link" })))));
            }))),
        (props === null || props === void 0 ? void 0 : props.tabsArray) &&
            ((_b = props === null || props === void 0 ? void 0 : props.tabsArray) === null || _b === void 0 ? void 0 : _b.map((tabs, idx) => {
                return tabs.eventKey === tab && React.createElement("div", null, tabs.tabContent);
            }))));
};
export default GenericDropdownTabs;
